// Sidebar entries owned by the Ticket module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { resources, scopes } from '@/utils/permission'
import { ticketPaths } from './paths'

export const ticketNav = {
    list: {
        title: 'ticket:sidebar_title',
        path: ticketPaths.ticket,
        rsname: resources.tickets,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
} satisfies Record<string, SidebarType>
